// src/pages/NotFoundPage.jsx
import React from 'react';
import '../styles/App.css';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import { getPath } from '../utils/functions';

function NotFoundPage() {
    const { t } = useTranslation();

    return (
        <>
            <Navbar />
            <div className="not-found-bg">
                <div className="container-fluid">
                    <div className="not-found-content">
                        <h1 className="not-found-code">{t('not_found.code')}</h1>
                        <h2 className="not-found-title">{t('not_found.title')}</h2>
                        <p className="not-found-desc">{t('not_found.description')}</p>
                        <a href={getPath('/')} className="not-found-btn">{t('not_found.back_home')}</a>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default NotFoundPage;
